import { render, staticRenderFns } from "./ProjectRoleBadge.vue?vue&type=template&id=0fbafc63&scoped=true&"
import script from "./ProjectRoleBadge.vue?vue&type=script&lang=js&"
export * from "./ProjectRoleBadge.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRoleBadge.vue?vue&type=style&index=0&id=0fbafc63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbafc63",
  null
  
)

export default component.exports